import { Button } from "@progress/kendo-react-buttons";
import { RadioButton, TextArea, TextBox } from "@progress/kendo-react-inputs";
import React, { useEffect, useState } from "react";
import { Upload } from "@progress/kendo-react-upload";
import { convertErrorsToArray } from "../../utils/formats";
import { toast } from "react-toastify";
import { HOST_API } from "../../config-global";
import { endpoints } from "../../utils/axios";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Image } from "antd";
import { IoMdClose } from "react-icons/io";
import useModelStore from "../../store/model-store";
import { Loader } from "@progress/kendo-react-indicators";
const Intersitial = ({ nextStep, isMobile, leadDetail, reload }) => {
  const { id } = useParams();
  const [modifyGutterHeight, setModifyGutterHeight] = useState("No");
  const [requireHarness, setRequireHarness] = useState("No");
  const [needWalkboards, setNeedWalkboards] = useState("No");
  const [gutterFootage, setGutterFootage] = useState("");
  const [spoutSavers, setSpoutSavers] = useState("");
  const [copperAccessories, setCopperAccessories] = useState("");
  const [extraLabor, setExtraLabor] = useState("");
  const [extraLaborReason, setExtraLaborReason] = useState("");
  const [shingleOverhang, setShingleOverhang] = useState("");
  const [dripEdgeFootage, setDripEdgeFootage] = useState("");
  const [fortyFootLadder, setFortyFootLadder] = useState("");
  const [walkboardsLength, setWalkboardsLength] = useState("");
  const [walkboardsReason, setWalkboardsReason] = useState("");
  const [deleteArray, setDeleteArray] = useState([]);
  const [orignalImages, setOrignalImages] = useState([]);
  const [files, setFiles] = useState([]);
  const [preview, setPreview] = useState([]);
  const { modelData, setModelData, resetModel } = useModelStore();
  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const handleAdd = async (event) => {
    const newFiles = event.affectedFiles.map((fileWrapper) =>
      fileWrapper.getRawFile()
    );
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setPreview((prevFiles) => [...prevFiles, ...newFiles]);
  };
  const handleRemove = (event) => {
    const removedFile = event.affectedFiles[0].getRawFile();
    setFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== removedFile.name)
    );
  };
  useEffect(() => {
    let data =leadDetail.installationDetails.isCompleted ?leadDetail.installationDetails : leadDetail?.installationDetailsDraft?.data;
    setModifyGutterHeight((data?.requireGutterHeightModification ? 'Yes' : 'No') || "");
    setRequireHarness((data?.requiresHarnessWork ? 'Yes' : 'No') || "");
    setNeedWalkboards((data?.walkboardsNeeded ? 'Yes' : 'No') || "");
    setGutterFootage(data?.gutterLoweringFootage || "");
    setSpoutSavers(data?.spoutSaversCount || "");
    setCopperAccessories(data?.copperAccessoriesFootage || "");
    setExtraLabor(data?.extraLaborHours || "");
    setExtraLaborReason(data?.extraLaborReason || "");
    setShingleOverhang(data?.cutRemoveShingleOverhangFootage || "");
    setDripEdgeFootage(data?.dripEdgeFlashingFootage || "");
    setFortyFootLadder(data?.fortyFootLadderNeeded || "");
    setWalkboardsLength(data?.walkboardLength || "");
    setWalkboardsReason(data?.walkboardReason || "");
    if (data?.compressedImages.length) {
      setOrignalImages(data?.images);
      let arr = [];
      data?.compressedImages.map((item) => {
        arr.push({
          type: "url",
          image: item,
        });
      });
      setPreview(arr);
    }
  }, [leadDetail]);
  const handleSubmit = async (url, finnalSubmit) => {
    const formData = new FormData();
    formData.append("requireGutterHeightModification", modifyGutterHeight ==='Yes' ? true : false);
    formData.append(
      "gutterLoweringFootage",
      modifyGutterHeight === "Yes" ? gutterFootage : ""
    );

    formData.append("spoutSaversCount", spoutSavers);
    formData.append("copperAccessoriesFootage", copperAccessories);
    formData.append("extraLaborHours", extraLabor);
    formData.append("extraLaborReason", extraLaborReason);

    formData.append("cutRemoveShingleOverhangFootage", shingleOverhang);
    formData.append("dripEdgeFlashingFootage", dripEdgeFootage);
    formData.append("requiresHarnessWork", requireHarness==='Yes' ? true : false);
    formData.append("fortyFootLadderNeeded", fortyFootLadder);

    formData.append("walkboardsNeeded", needWalkboards==='Yes' ? true : false);
    formData.append(
      "walkboardLength",
      needWalkboards === "Yes" ? walkboardsLength : ""
    );
    formData.append(
      "walkboardReason",
      needWalkboards === "Yes" ? walkboardsReason : ""
    );

    if (needWalkboards === "Yes" && files && files.length > 0) {
      files.forEach((file, index) => {
        formData.append("files", file);
      });
    }

    try {
      await axios.put(url, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (deleteArray.length > 0) {
        await axios.put(
          `${HOST_API}${endpoints.leads.installations_draft_delete_images(id)}`,
          { imageUrls: deleteArray },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "Content-Type": "application/json",
            },
          }
        );
      }
      if (finnalSubmit) {
        toast.success("Successfully submitted!");
        nextStep();
      }else{
      toast.success("Draft saved successfully.");
        setModelData({ ...modelData, open: false });
      }
      setDeleteArray([]);
      reload();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorsArray = convertErrorsToArray(error?.response?.data?.data);
      if (errorsArray.length > 0) {
        errorsArray.forEach((err) => toast.error(err));
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Internal Server Error");
      }
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div className={isMobile ? "k-mb-10" : "k-scrollable"}>
        <span className="k-form-separator" />

        {/* Modify gutter height section */}
        <div
          className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
            !isMobile && "k-flex-row"
          }  k-mt-3`}
        >
          <h3 className="k-my-2">
            Does this installation require to modify existing gutter height?
          </h3>
          <div className="k-d-flex k-gap-6 k-my-3">
            <div>
              <RadioButton
                disabled={leadDetail.mhalt}
                name="modifyGutter"
                value="No"
                checked={modifyGutterHeight === "No"}
                label="No"
                onChange={() => setModifyGutterHeight("No")}
              />
            </div>
            <div>
              <RadioButton
                disabled={leadDetail.mhalt}
                name="modifyGutter"
                value="Yes"
                checked={modifyGutterHeight === "Yes"}
                label="Yes"
                onChange={() => setModifyGutterHeight("Yes")}
              />
            </div>
          </div>
        </div>

        {modifyGutterHeight === "Yes" && (
          <div className="k-w-full k-mb-4">
            <p className="k-font-bold">Total footage of gutter to be lowered</p>
            <TextBox
              disabled={leadDetail.mhalt}
              type="number"
              placeholder="Total footage of gutter to be lowered"
              value={gutterFootage}
              onChange={(e) => setGutterFootage(e.value)}
              className="k-w-full"
            />
          </div>
        )}

        <span className="k-form-separator" />
        <h3>Misc Leaf Filter</h3>
        <span className="k-form-separator" />

        {/* First row */}
        <div
          className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
            !isMobile && "k-flex-row"
          }`}
        >
          <div className="k-w-full md:k-flex-basis-1/2">
            <p className="k-font-bold">Number of Spout Savers</p>
            <TextBox
              disabled={leadDetail.mhalt}
              type="number"
              placeholder="Number of Spout Savers"
              value={spoutSavers}
              onChange={(e) => setSpoutSavers(e.value)}
              className="k-w-full"
            />
          </div>
          <div className="k-w-full md:k-flex-basis-1/2">
            <p className="k-font-bold">Footage of Copper Accessories</p>
            <TextBox
              disabled={leadDetail.mhalt}
              type="number"
              placeholder="Footage of Copper Accessories"
              value={copperAccessories}
              onChange={(e) => setCopperAccessories(e.value)}
              className="k-w-full"
            />
          </div>
        </div>

        {/* Second row */}
        <div
          className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
            !isMobile && "k-flex-row"
          } k-mt-4`}
        >
          <div className="k-w-full md:k-flex-basis-1/2">
            <p className="k-font-bold">How many hours of extra labor</p>
            <TextBox
              disabled={leadDetail.mhalt}
              type="number"
              placeholder="How many hours of extra labor"
              value={extraLabor}
              onChange={(e) => setExtraLabor(e.value)}
              className="k-w-full"
            />
          </div>
        </div>
        <div className="k-w-full k-mb-4">
          <p className="k-font-bold">Extra Labor Reason</p>
          <TextArea
          disabled={leadDetail.mhalt}
            placeholder="Extra Labor Reason"
            rows={3}
            value={extraLaborReason}
            onChange={(e) => setExtraLaborReason(e.value)}
            className="k-w-full"
          />
        </div>

        {/* Third row */}
        <div
          className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
            !isMobile && "k-flex-row"
          } k-mt-4`}
        >
          <div className="k-w-full md:k-flex-basis-1/2">
            <p className="k-font-bold">Cut and remove shingle overhang</p>
            <TextBox
              disabled={leadDetail.mhalt}
              type="number"
              placeholder="Cut and remove shingle overhang"
              value={shingleOverhang}
              onChange={(e) => setShingleOverhang(e.value)}
              className="k-w-full"
            />
          </div>
          <div className="k-w-full md:k-flex-basis-1/2">
            <p className="k-font-bold">Footage of Drip Edge/Flashing</p>
            <TextBox
              type="number"
              disabled={leadDetail.mhalt}
              placeholder="Footage of Drip Edge/Flashing"
              value={dripEdgeFootage}
              onChange={(e) => setDripEdgeFootage(e.value)}
              className="k-w-full"
            />
          </div>
        </div>

        {/* Ladder section */}
        <div className="k-w-full k-mb-4">
          <p className="k-font-bold">Is a forty foot ladder needed</p>
          <TextArea
          disabled={leadDetail.mhalt}
            placeholder="Is a forty foot ladder needed"
            rows={3}
            value={fortyFootLadder}
            onChange={(e) => setFortyFootLadder(e.value)}
            className="k-w-full"
          />
        </div>
        <span className="k-form-separator" />

        {/* Harness section */}
        <div
          className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
            !isMobile && "k-flex-row"
          }  k-mt-3`}
        >
          <h3 className="k-my-2">Does this install require harness work</h3>
          <div className="k-d-flex k-gap-6 k-my-3">
            <div>
              <RadioButton
                disabled={leadDetail.mhalt}
                name="requireHarness"
                value="No"
                checked={requireHarness === "No"}
                label="No"
                onChange={() => setRequireHarness("No")}
              />
            </div>
            <div>
              <RadioButton
                disabled={leadDetail.mhalt}
                name="requireHarness"
                value="Yes"
                checked={requireHarness === "Yes"}
                label="Yes"
                onChange={() => setRequireHarness("Yes")}
              />
            </div>
          </div>
        </div>

        <span className="k-form-separator" />

        {/* Walkboards section */}
        <div
          className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
            !isMobile && "k-flex-row"
          } k-mt-3`}
        >
          <h3 className="k-my-2">Does this install need walkboards</h3>
          <div className="k-d-flex k-gap-6 k-my-3">
            <div>
              <RadioButton
                disabled={leadDetail.mhalt}
                name="needWalkboards"
                value="No"
                checked={needWalkboards === "No"}
                label="No"
                onChange={() => setNeedWalkboards("No")}
              />
            </div>
            <div>
              <RadioButton
                disabled={leadDetail.mhalt}
                name="needWalkboards"
                value="Yes"
                checked={needWalkboards === "Yes"}
                label="Yes"
                onChange={() => setNeedWalkboards("Yes")}
              />
            </div>
          </div>
        </div>

        {needWalkboards === "Yes" && (
          <>
            <span className="k-form-separator" />
            <div
              className={`k-d-flex ${isMobile && "k-flex-col"} k-gap-4 ${
                !isMobile && "k-flex-row"
              }`}
            >
              <div className="k-w-full md:k-flex-basis-1/2">
                <p className="k-font-bold">Walkboards Length</p>
                <TextBox
                  disabled={leadDetail.mhalt}
                  type="number"
                  placeholder="Walkboards Length"
                  value={walkboardsLength}
                  onChange={(e) => setWalkboardsLength(e.value)}
                  className="k-w-full"
                />
              </div>
              <div className="k-w-full md:k-flex-basis-1/2">
                <p className="k-font-bold">Walkboards Reason</p>
                <TextBox
                  disabled={leadDetail.mhalt}
                  placeholder="Walkboards Reason"
                  value={walkboardsReason}
                  onChange={(e) => setWalkboardsReason(e.value)}
                  className="k-w-full"
                />
              </div>
            </div>
            <div className="k-mt-4">
              <p className="k-font-bold">{leadDetail.mhalt ? 'Pictures' : 'Add pictures'}</p>
        {!leadDetail.mhalt &&      <Upload
                batch={false}
                multiple={true}
                accept="image/*"
                defaultFiles={[]}
                withCredentials={false}
                saveUrl={
                  "https://demos.telerik.com/kendo-ui/service-v4/upload/save"
                }
                removeUrl={
                  "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
                }
                onAdd={handleAdd}
                onRemove={handleRemove}
                showFileList={false}
              />}
              <div
                className="k-display-flex k-mt-4"
                style={{ gap: "15px", flexWrap: "wrap" }}
              >
                {preview.map((item, index) => (
                  <div style={{ position: "relative" }}>
               {!leadDetail.mhalt &&  <IoMdClose
                      onClick={() => {
                        if (item.type == "url") {
                          setDeleteArray((prev) => [
                            ...prev,
                            item.image,
                            orignalImages[index],
                          ]);
                          setPreview((prev) =>
                            prev.filter((img) => img.image !== item.image)
                          );
                        } else {
                          setPreview((prev) =>
                            prev.filter((img) => img !== item)
                          );
                        }
                      }}
                      style={{
                        position: "absolute",
                        zIndex: 1111,
                        color: "red",
                        fontSize: "1.5rem",
                        top: "-10px",
                        right: "-8px",
                        cursor: "pointer",
                      }}
                    />}
                    <div className="k-card">
                      <Image
                        height={150}
                        width={150}
                        src={
                          item.type == "url"
                            ? item.image
                            : URL.createObjectURL(item)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

    {!leadDetail.mhalt &&  <div
        className={`k-display-flex k-justify-content-end k-mt-8 ${
          !isMobile && "k-mb-2"
        } k-fixed-footer`}
      >
        <Button
          style={{ width: 130 }}
          type="button"
          disabled={draftLoading || loading}
          onClick={() => {
            setDraftLoading(true);
            handleSubmit(
              `${HOST_API}${endpoints.leads.installations_draft(id)}`,
              false
            );
          }}
          className="k-mr-2"
          size={isMobile ? "small" : "large"}
        >
          {draftLoading ? (
            <Loader
              size="small"
              type="converging-spinner"
              style={{ color: "black" }}
            />
          ) : (
            "Save As Draft"
          )}
        </Button>
        <Button
          type="button"
          disabled={loading || draftLoading}
          style={{ width: "100px" }}
          primary={true}
          onClick={() => {
            setLoading(true);
            handleSubmit(
              leadDetail?.installationDetailsDraft?.isDraft
                ? `${HOST_API}${endpoints.leads.installations_draft_complete(
                    id
                  )}`
                : `${HOST_API}${endpoints.leads.installations_complete(id)}`,
              true
            );
          }}
          className="k-button-green k-mr-2"
          size={isMobile ? "small" : "large"}
        >
          {loading ? (
            <Loader
              size="small"
              type="converging-spinner"
              style={{ color: "white" }}
            />
          ) : (
            "Submit"
          )}
        </Button>
      </div>}
    </div>
  );
};

export default Intersitial;
